import { CompanyStructureForPlanningResponse, CompanyStructureHoliday } from '@/types/service-response'

export class Holiday {
  public constructor (
    readonly id: number,
    readonly date: string
  ) {}

  static createFromResponse (responseData: CompanyStructureForPlanningResponse): Array<Holiday> {
    let result: Array<Holiday> = []
    if (responseData.freitage) {
      result = responseData.freitage.map((holiday: CompanyStructureHoliday) => {
        return new Holiday(
          holiday.ID,
          holiday.Datum,
        )
      })
    }
    return result
  }
}
